export default __webpack_public_path__ + "static/media/blog-img251.5079945d.jpg";